import { types } from 'mobx-state-tree'

const mainPageTagModel = types.model('mainPageTagModel', {
  id: types.optional(types.integer, 0),
  name: types.maybeNull(types.string),
  linkedResourcesCount: types.optional(types.integer, 0),
})

export default mainPageTagModel
